import React from "react";
import LoadingIndicator from "./LoadingIndicator";
import { strings } from "../../resources/strings";

interface PageContentLoadingProps {
  loadingText: string;
}

const PageContentLoading: React.FC<PageContentLoadingProps> = ({
  loadingText,
}) => {
  return (
    <div
      data-testid="page-content-loading"
      className="absolute inset-0 w-screen  h-[calc(100vh-5rem)] mt-[5rem] pointer-events-none"
    >
      <div className="flex flex-col h-full justify-center items-center scale-150">
        <div className="translate-y-[-4rem]">
          <LoadingIndicator />
          {/* Status, not a heading — see LoadingIndicator. This one rendered
              as a route's ONLY heading during load, leaving it with no h1. */}
          <p
            role="status"
            className="mb-2 text-lg font-semibold  tracking-tight text-gray-900"
          >{`${strings.pageContentLoading} ${loadingText}...`}</p>
        </div>
      </div>
    </div>
  );
};

export default PageContentLoading;
